import { DealEntity } from '@lib/deals';
import vest, { enforce, test } from 'vest';

function hasDuplicateContent(arr) {
  const seenIds = new Set();
  for (const obj of arr) {
    if (seenIds.has(obj.vtr_id)) {
      return true; // Found a duplicate ID
    }
    seenIds.add(obj.vtr_id);
  }
  return false; // No duplicate IDs found
}

export const P2CValidationSuite = vest.create(
  (personcontentmapping) => {

    test('Mandatory', 'Person is required.', () => {
      enforce(personcontentmapping?.persons[0]?.vtr_id).isTruthy();
    });

    test('Mandatory', 'At least one Content is required.', () => {
      const content_data_array = (personcontentmapping.associated_content as Array<Partial<DealEntity>>)
        .filter(x => x)
        .map(x => (x.vtr_id ?? ''))
        .filter(x => x !== '');
        
      enforce(personcontentmapping.associated_content && content_data_array?.length > 0).isTruthy();
    });

    test('Mandatory', 'Invalid Content added', () => {
      const content_data_array = (personcontentmapping.associated_content as Array<Partial<DealEntity>>);
      enforce(personcontentmapping.associated_content && !content_data_array?.some((obj) => obj?.vtr_id === '')).isTruthy();
    });

    test('Mandatory', 'Duplicate Content Added', () => {
      const content_data_array = (personcontentmapping.associated_content as Array<Partial<DealEntity>>);
      enforce(personcontentmapping.associated_content && !hasDuplicateContent(content_data_array)).isTruthy();
    });

    test('Mandatory', 'Maximum 25 Content can be associated at a time.', () => {
      const content_data_array = (personcontentmapping.associated_content as Array<Partial<DealEntity>>)
        .filter(x => x)
        .map(x => (x.vtr_id ?? ''))
        .filter(x => x !== '');
      enforce(content_data_array?.length <= 25).isTruthy();
    });
  }
); 